module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Cms', {
    attrs: {
      "pageTitle": 'Conteúdo da Página Institucional',
      "pageName": 'about'
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fbc11918","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cms/AboutCms.vue
// module id = 781
// module chunks = 1